import { CreateEditInternalLayerVersionContent } from './CreateEditInternalLayerVersionContent';
import { useUscgMapContext } from './UscgMapContext';

export function DraftNewVersionPanel({ onBack }: { onBack: () => void }) {
  const { sidebarSelectedInternalLayer } = useUscgMapContext();

  if (!sidebarSelectedInternalLayer) {
    return null;
  }

  return (
    <div className="dark tw:flex tw:h-full tw:flex-col tw:gap-3 tw:p-2 tw:text-foreground">
      <CreateEditInternalLayerVersionContent
        internalLayer={sidebarSelectedInternalLayer}
        onBack={onBack}
        showCreateDraftButton
      />
    </div>
  );
}
